import React from 'react';
import { FadeIn } from './FadeIn';
export function PainStorySection() {
  return <section className="py-16 md:py-24 bg-cream-dark relative" data-id="element-159">
      <div className="absolute top-0 left-0 w-full h-px bg-cinnamon/20" data-id="element-160"></div>
      <div className="absolute bottom-0 left-0 w-full h-px bg-cinnamon/20" data-id="element-161"></div>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-162">
        <FadeIn data-id="element-163">
          <div className="space-y-8 text-lg md:text-xl text-dark-brown/90 leading-relaxed" data-id="element-164">
            <p className="font-serif text-2xl md:text-3xl italic text-cinnamon mb-8" data-id="element-165">
              Seguramente conoces esa sensación...
            </p>
            <p data-id="element-166">
              Te despiertas un lunes cansada, te miras al espejo y notas tu cara
              hinchada. Vas al armario por tus jeans favoritos, aguantas la
              respiración, saltas un poco... y el cierre simplemente no sube.
            </p>
            <p className="font-medium" data-id="element-167">
              No es que hayas ganado "grasa" de la noche a la mañana. Es
              inflamación sistémica.
            </p>
            <p data-id="element-168">
              Tu cuerpo está reteniendo líquidos y bloqueando tu metabolismo
              porque la comida procesada en este país está diseñada para
              mantenerte adicta, cansada y con el abdomen inflamado.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}